<!-- eslint-disable vue/no-v-html -->
<template>
  <section
    ref="codeEmbedRef"
    :class="{
      'code-embed-component': true,
    }"
  >
    <div
      :class="{
        'code-embed flex justify-center': true,
      }"
      v-html="doc?.body.innerHTML ? doc.head.innerHTML + doc.body.innerHTML : codeInput?.code"
    ></div>
  </section>
</template>

<script setup lang="ts">
import type { CodeEmbed } from '~/sanity/types';
import { addScriptTagToHead, removeScriptTagFromHead } from '~/utils/ScriptsUtil';

const props = defineProps<CodeEmbed>();

const { codeInput } = toRefs(props);
const doc = ref<Document>();
const scriptTags = ref<HTMLScriptElement[]>([]);
const codeEmbedRef = ref<HTMLElement | null>(null);

onMounted(async () => {
  if (!codeInput.value || !codeInput.value.code) return;
  const parser = new DOMParser();
  doc.value = parser.parseFromString(codeInput.value?.code || '', 'text/html');
  scriptTags.value = extractScriptsFromDoc(doc.value);
  scriptTags.value.forEach(addScriptTagToHead);
  doc.value.querySelectorAll('script').forEach((script) => script.remove());

  // Dispatch custom event after DOM update so parents can query rendered content
  await nextTick();
  codeEmbedRef.value?.dispatchEvent(
    new CustomEvent('code-embed-rendered', { bubbles: true, detail: codeEmbedRef.value })
  );
});

onUnmounted(() => {
  scriptTags.value.forEach(removeScriptTagFromHead);
});
</script>

<style lang="scss">
.code-embed {
  iframe {
    height: 141px;
    margin-bottom: 20px;
  }
}

@media (min-width: 768px) {
  .code-embed {
    iframe {
      height: 217px;
    }
  }
}
@media (min-width: 1024px) {
  .code-embed {
    iframe {
      height: 616px;
    }
  }
}
</style>
